export default {
  login: {
    succeed: "loginSucceed",
    failed: "loginFailed",
    usernameRequired: "usernameRequired",
    passwordRequired: "passwordRequired"
  },
  logout: {
    succeed: "logoutSucceed",
    failed: "logoutFailed"
  },
  request: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    processing: "requestProcessing",
    delayed: "requestDelayed"
  },
  session: {
    invalidToken: "session_not_exists",
    invalidSession: "session_expired",
    inactiveAccount: "account_inactive",
  },
  forgotPassword: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    verificationCodeRequired: "verificationCodeRequired"
  },
  debounceSearch: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  memberSignUp: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    passwordRequired: "passwordRequired"
  },
  memberTacValidate: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    tacCodeRequired: "tacCodeRequired"
  },
  memberRenewTac: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getBalance: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  bankLookUp: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getMemberBankList: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getBankingMode: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  updatePassword: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    passwordRequired: "passwordRequired",
    newPasswordRequired: "newPasswordRequired"
  },
  memberAddBank: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    bankIdRequired: "bankIdRequired",
    bankNameRequired: "bankNameRequired",
    bankAccHolderRequired: "bankAccHolderRequired",
    bankAccNoRequired: "bankAccNoRequired",
    tacCodeRequired: "tacCodeRequired"
  },
  memberBankTac: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  iBankTransfer: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
    bankIdRequired: "bankIdRequired"
  },
  addDepositTicket: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
    bankIdRequired: "bankIdRequired"
  },
  getMemberTicketList: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getPromotionStatus: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  addWithdrawTicket: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getStatement: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getMemberGameResult: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getPromo:{
    success: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    dateRequired:"dateRequired"
  },
  getBet:{
    success: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    dateRequired:"dateRequired"
  },
  getInbox:{
    success: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  claimInbox:{
    success: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    bonusIdRequired: "bonusIdRequired"
  },
  getReferralCode:{
    success: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  addReferralCode:{
    success: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getTopTen:{
    success: "requestSucceed",
    failed: "requestFailed"
  },
  launchGame:{
    success: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  transferTac: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  memberTransfer:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    tacCodeRequired: "tacCodeRequired",
    recipientIdRequired: "recipientIdRequired",
    transferAmountRequired: "transferAmountRequired"
  },
  getQuestion:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  submitReview:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    commentRequired: "commentRequired",
    ratingRequired: "ratingRequired"
  },
  getSurveyList:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  submitVideoUrl:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    videoLinkRequired: "videoLinkRequired"
  },
  gsPayTransfer: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  gspaySol:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  gspayEwallet:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  uPay:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  getCouponDetails:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  couponGSPayTransfer: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  iBankTransferCoupon: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
    bankIdRequired: "bankIdRequired"
  },
  addDepositTicketCoupon:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
    bankIdRequired: "bankIdRequired"
  },
  getRefLink:{
    accountIdRequired: "accountIdRequired",
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  updateEmail:{
    accountIdRequired: "accountIdRequired",
    emailRequired: "emailRequired",
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  peBankTransfer: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
    paymentMethodRequired: "paymentMethodRequired",
    bankIdRequired: "bankIdRequired"
  },
  pepin: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
    paymentMethodRequired: "paymentMethodRequired",
    bankIdRequired: "bankIdRequired"
  },
  peBankTransferCoupon: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
    bankIdRequired: "bankIdRequired"
  },
  winpay:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
    telcoCodeRequired: "telcoCodeRequired",
    reloadPinCodeRequired: "reloadPinCodeRequired",
    bankIdRequired: "bankIdRequired"
  },
  mytelco:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
    telcoCodeRequired: "telcoCodeRequired",
    reloadPinCodeRequired: "reloadPinCodeRequired",
    bankIdRequired: "bankIdRequired"
  },
  winpayCoupon:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
    telcoCodeRequired: "telcoCodeRequired",
    reloadPinCodeRequired: "reloadPinCodeRequired",
    bankIdRequired: "bankIdRequired"
  },
  sulifu:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  getXchangeRate:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getReferCount:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getReferRebate:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getReferCountDetail:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getReferRebateDetail:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getRebateChart:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getRebate: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getRebateDownline:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getTurnoverDownline: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getTurnoverProvider: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  claimRebate:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  claimRebateDownline:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getProviderGameOfflist:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    providerRequired: ""
  },
  launchWbet:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchEpic:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchEpic2:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchLive22:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchMegaH5:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchHabanero:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchSpadeGaming:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchPragmatic:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchJili:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchOneapi:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchJoker:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchCq9:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getRefereeList:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getAdjustmentDetails:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getSpadeResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getHbResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getEpic2Result:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getLive22Result:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getJokerResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getMegaH5Result:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getCq9Result:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getJiliResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    resultIdRequired: "resultIdRequired"
  },
  getOneapiResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    resultIdRequired: "resultIdRequired"
  },
  getPpsResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    resultIdRequired: "resultIdRequired"
  },
  getMiniGameBalance:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  spinWheel:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  getReferralRebateList:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  cnyDeposit:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  missionDetails:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  missionClaim:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  rayaDeposit:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  tierDeposit:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  eurocup:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  eurocupCheck:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  getNumbers:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  getWinners:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },

  /* cms */
  getAnnBanner:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  getSlideBanner:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  getPromoBanner:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  getSeo:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  getNewsList:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  getNewsDetails:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  getSeo:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
};
